import Vue from 'vue';
import store from '@/store';
import {MapActionsSnackbarModule} from "@/store/modules/snackbar/map-actions.snackbar";
import ContatoModel from "@/models/cliente/contato.model";

class ContatoService {

    STATUS_OK: number = 200;

    async cadastrar(body: ContatoModel): Promise<any> {
        return await Vue.prototype.$axios.post('contatos', body)
            .then((response: any) => {
                if (response.status === this.STATUS_OK) {
                    store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Contato salvo com sucesso!');
                    const contato: ContatoModel = response.data;
                    return contato;
                }
            })
            .catch((error: any) => {
                store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
                console.error(error.response);
            });
    }

    async atualizar(body: ContatoModel): Promise<any> {
        return await Vue.prototype.$axios.put(`contatos/${body.id}`, body)
            .then((response: any) => {
                if (response.status === this.STATUS_OK) {
                    store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Contato atualizado com sucesso!');
                    const contato: ContatoModel = response.data;
                    return contato;
                }
            })
            .catch((error: any) => {
                store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
                console.error(error.response);
            });
    }

    async delete(id: number | null): Promise<any> {
        await Vue.prototype.$axios.delete(`contatos/${id}`)
            .then((response: any) => {
                if (response.status === this.STATUS_OK) {
                    store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Contato deletado com sucesso!');
                }
            })
            .catch((error: any) => {
                console.error(error.response);
            });
    }

    async buscarTodos(idCliente: number): Promise<any> {
        return await Vue.prototype.$axios.get(`contatos/cliente/${idCliente}`)
            .then((response: any) => {
                if (response.status === this.STATUS_OK) {
                    const lista: Array<ContatoModel> = response.data;
                    return lista;
                } else {
                    store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, 'Falha inesperada ao carregar a lista de clientes');
                }
            })
            .catch((error: any) => {
                console.error(error.response);
            });
    }

}

export default new ContatoService();
